if (typeof L2H === "undefined" || L2H === null) {
  window.L2H = {};
}

L2H.loadGoogleAnalytics = function() {
  L2H.googleAnalyticsLoaded = true;
  if (L2H.debug) {
    console.log("L2H DEBUG: Loading google analytics")
  }
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','l2hga');
}
